//线上服务
const url = {
	 baseURL: "https://yaocaigo.com:8186/" ,//正式地址
    //baseURL: "http://127.0.0.1:8181",//本地接口地址
    // baseURL: "http://123.56.136.135:8080/",   //测试接口
	Url: "https://yaocaigo.com:8186/",
    imgUrl: "https://ycgshop.oss-cn-beijing.aliyuncs.com/", //图片地址
    imgUrl1: "https://backend.yaocaigo.com:8086/",//服务器上的图片地址
    wsUrl: "ws://backend.yaocaigo.com:16666/ws",//websocked服务
	// wsUrl: "ws://192.168.11.126:16666/ws",//websocked服务
	// baseURL: "https://backend.yaocaigo.com:8084/",  //线上接口弃
	// Url: "https://backend.yaocaigo.com:8084/",
	// baseURL: "http://127.0.0.1:80/",//接口地址
}

//测试服务
// const url = {
//     baseURL: "http://123.56.136.135:8080/",
//     Url: "http://123.56.136.135:8080/",
//     imgUrl: "https://ycgshop.oss-cn-beijing.aliyuncs.com/", //图片地址
//     imgUrl1: "https://backend.yaocaigo.com:8086/",//服务器上的图片地址
//     wsUrl: "ws://123.56.136.135:16666/ws",//websocked服务
// }

// //本地服务1
// const url = {
//     baseURL: "http://192.168.1.111:8080/",
//     Url: "https://backend.yaocaigo.com:8084/",
//     imgUrl: "https://ycgshop.oss-cn-beijing.aliyuncs.com/", //图片地址
//     imgUrl1: "https://backend.yaocaigo.com:8086/",//服务器上的图片地址
//     wsUrl: "ws://192.168.1.111:16666/ws",//websocked服务
// }

// //本地服务2
// const url = {
//     baseURL: "http://192.168.1.112:8080/",
//     Url: "https://backend.yaocaigo.com:8084/",
//     imgUrl: "https://ycgshop.oss-cn-beijing.aliyuncs.com/", //图片地址
//     imgUrl1: "https://backend.yaocaigo.com:8086/",//服务器上的图片地址
//     wsUrl: "ws://192.168.1.112:16666/ws",//websocked服务
// }

// const url = {
//     baseURL: "http://127.0.0.1:80/",//接口地址
//     // baseURL: "http://124.70.10.212:9669/",//接口地址
//     Url: "https://backend.yaocaigo.com:8084/",//上传地址
//     imgUrl: "https://ycgshop.oss-cn-beijing.aliyuncs.com/",//图片地址
//     imgUrl1: "https://backend.yaocaigo.com:8086/",//服务器本地图片地址
// }
export default url



// WEBPACK FOOTER //
// ./src/components/api/url.js